import { createSvgIcon } from '@mui/material/utils'

const ArrowRightCircle = createSvgIcon(
  <>
    <circle
      cx="19.461"
      cy="18.7865"
      r="18.1387"
      fill="white"
      stroke="#D8D9DC"
      strokeWidth="1.29562"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.2537 19.4308L16.4799 11.6571L17.3961 10.741L26.0859 19.4308L26.0859 19.4309L25.1698 20.347L17.3961 28.1207L16.4799 27.2046L24.2537 19.4308Z"
      fill="#262D3D"
    />
  </>,
  'ArrowRightCircle'
)

export default ArrowRightCircle
